import { FC } from 'react';
import { Button, ButtonStyles, Icon, Icons, Table, TextInput, TextInputSizes } from '@silverfort/sf-components';
import { TOKEN_TABLE_COLUMNS } from '../../../consts';

const TokensTableLoader: FC = () => (
    <Table loading tableContainerClassName="font-sf" columns={TOKEN_TABLE_COLUMNS} rows={[]} bodyHeight={48 * 3} />
);

const TokensFooterLoader: FC = () => (
    <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
            <span className="font-sf text-13 leading-[15.51px]">Max Tokens</span>
            <TextInput
                disabled
                numbersOnly
                inputSize={TextInputSizes.Small}
                placeholder="Max Tokens"
                value=""
                onChange={() => {}}
            />
        </div>
        <Button disabled text="Test All" buttonStyle={ButtonStyles.Tertiary} />
    </div>
);

const TokensSectionLoader: FC = () => (
    <div className="rounded-[8px] border border-sf-gray-100">
        <div className="px-4 h-14 flex justify-between items-center border-b border-sf-gray-100">
            <span className="font-sf font-medium text-13 leading-[15.87px]">Tokens</span>
            <div className="h-8 w-8 flex justify-center items-center">
                <Icon icon={Icons.ChevronUp} className="text-sf-gray-400" />
            </div>
        </div>
        <div className="overflow-hidden transition-[max-height] ease-in-out duration-500 h-fit">
            <div className="flex flex-col gap-4 p-4">
                <div className="flex gap-2 rounded-[8px]">
                    <div className="h-8 p-3 flex items-center justify-center">
                        <span className="h-4 text-center font-sf text-13 font-medium leading-[15.87px] text-sf-gray-300">
                            Active
                        </span>
                    </div>
                    <div className="h-8 p-3 flex items-center justify-center">
                        <span className="h-4 text-center font-sf text-13 font-medium leading-[15.87px] text-sf-gray-300">
                            Unused
                        </span>
                    </div>
                    <div className="h-8 p-3 flex items-center justify-center">
                        <span className="h-4 text-center font-sf text-13 font-medium leading-[15.87px] text-sf-gray-300">
                            Disabled
                        </span>
                    </div>
                </div>
                <TokensTableLoader />
                <TokensFooterLoader />
            </div>
        </div>
    </div>
);

export default TokensSectionLoader;
